import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';
import ActionsMenu from 'utils/ActionsMenuDatagrid';
import ActionLabels from 'utils/ActionLabelsDatagrid';
import CurrencyFormatter from 'utils/helpers/CurrencyFormatter';

export const PageSTPHook = ({
  listSTPAction,
  cleanTransferSTPClean,
  detailSTPAction,
  listTransactionsSTP,
  detailsTransactionsSTP,
  cleanDetailSTPAction,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  reportTransactionsFraud,
  actionReportTransactionsFraud,
  actionReportTransactionsChargeback,
  reportTransactionsChargeback,
  transactionId,
  onClose,
}) => {
  const { payload } = listTransactionsSTP || {};
  const { response } = detailsTransactionsSTP || {};
  const { rows, pagination } = payload || {};

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(50);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState(false);
  const [isDialogOpenDetails, setIsDialogOpenDetails] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [action, setAction] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openActionFraud, setOpenActionFraud] = useState(false);
  const [descriptionTransaction, setDescriptionTransaction] = useState('');
  const [error, setError] = useState(false);
  const [loadingFraudAndChargeback, setLoadingFraudAndChargeback] = useState(false);
  const [isError, setIsError] = useState(false);
  const [IdOrder, setIDorder] = useState('');
  const [mappedRows, setMappedRows] = useState([]);

  useEffect(() => {
    if (transactionId) {
      setLoading(true);
      setIsDialogOpenDetails(true);
      detailSTPAction(transactionId);
    }
  }, [transactionId, setIsDialogOpenDetails, detailSTPAction]);

  useEffect(() => {
    if (response?.response?.status > 200) {
      setIsDialogOpenDetails(true);
      setDialogMessage('Error');
      setDialogMessage(response?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [response]);

  useEffect(() => {
    // Verificar si searchParams tiene algún valor
    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      listSTPAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    return () => {
      cleanTransferSTPClean();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, listSTPAction, cleanTransferSTPClean]);

  useEffect(() => {
    // Verificar si searchParams tiene algún valor
    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      listSTPAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size]);

  useEffect(() => {
    if (listTransactionsSTP?.status === 200) {
      setLoading(false);
    } else if (listTransactionsSTP?.payload?.response?.status > 200) {
      setDialogMessage(listTransactionsSTP?.payload?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [listTransactionsSTP]);

  const onSubmit = (data) => {
    const { from_date, to_date, beneficiary_account, reference } = data;

    const areDatesProvided = from_date !== '' && to_date !== '';
    const isAuthorizationOrCardProvided = beneficiary_account !== '' || reference !== '';

    if (areDatesProvided || isAuthorizationOrCardProvided) {
      setLoading(true);
      setPage(1);
      /* eslint-disable no-unused-vars */
      const filteredData = Object.fromEntries(
        Object.entries(data).filter(([_, value]) => value !== ''),
      );
      /* eslint-enable no-unused-vars */
      setSearchParams(filteredData);
      setErrorMessage('');
    } else {
      setErrorMessage(
        'Por favor, complete al menos uno de los siguientes campos: Referencia, Clave STP o ambas fechas.',
      );
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangePageSize = (newSize) => {
    setSize(newSize);
    setPage(1);
  };

  useEffect(() => {
    if (rows) {
      const updatedRows = rows.map((row) => ({
        ...row,
        id: `${row.id}`,
      }));
      setMappedRows(updatedRows);
    }
  }, [rows]);

  const handleIdButtonClick = (id) => {
    setIDorder(id);
    if (id) {
      setIsDialogOpenDetails(true);
      detailSTPAction(id)
        .then(() => setLoading(false))
        .catch(() => {
          setDialogMessage('Error');
          setDialogMessage('Error al cargar los detalles de la transferencia.');
          setIsDialogOpen(true);
          setLoading(false);
        });

      return () => {
        cleanDetailSTPAction();
      };
    }
  };

  const handleFraudPrevention = (data) => {
    setLoadingFraudAndChargeback(true);
    const payload = {
      txn_payment_id: data,
      descriptionTransaction,
      payment_provider_name: 'STP',
    };
    actionReportTransactionsFraud({ ...payload });
  };

  const handleChargebackPrevention = (data) => {
    setLoadingFraudAndChargeback(true);
    const payload = {
      txn_payment_id: data,
      descriptionTransaction,
      payment_provider_name: 'STP',
    };
    actionReportTransactionsChargeback({ ...payload });
  };

  const handleConfirm = () => {
    if (descriptionTransaction === '') {
      setError(true);
    } else {
      setError(false);
      if (action === 'fraud') {
        handleFraudPrevention(selectedRowId);
      } else if (action === 'chargeback') {
        handleChargebackPrevention(selectedRowId);
      }
    }
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    setIsDialogOpenDetails(false);
    cleanDetailSTPAction();
    if (transactionId) {
      onClose();
    }
  };

  const handleOpenPopUp = (action, rowId) => {
    setAction(action);
    setSelectedRowId(rowId);
    setOpenActionFraud(true);
  };

  const handleCloseFraudChargeback = () => {
    setOpenActionFraud(false);
    setDescriptionTransaction('');
    setError(false);
    setDialogMessage('');

    if (action === 'fraud') {
      cleanReportTransactionsFraud();
    } else if (action === 'chargeback') {
      cleanReportPrepaidChargebackDetails();
    }

    setLoading(true);

    listSTPAction(page, size, searchParams)
      .then(() => setLoading(false))

      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (reportTransactionsChargeback?.status === 200) {
      setDialogMessage('La operación se completó con éxito.');
      setIsError(false);
      setLoadingFraudAndChargeback(false);
      detailSTPAction(IdOrder);
    } else if (reportTransactionsChargeback?.payload?.response?.status > 200) {
      setLoadingFraudAndChargeback(false);
      setDialogMessage(
        reportTransactionsChargeback?.payload?.response?.data?.detail || 'Ha ocurrido un error.',
      );
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTransactionsChargeback]);

  useEffect(() => {
    if (reportTransactionsFraud?.status === 200) {
      setDialogMessage('La operación se completó con éxito.');
      setIsError(false);
      setLoadingFraudAndChargeback(false);
      detailSTPAction(IdOrder);
    } else if (reportTransactionsFraud?.payload?.response?.status > 200) {
      setLoadingFraudAndChargeback(false);
      setDialogMessage(
        reportTransactionsFraud?.payload?.response?.data?.detail || 'Ha ocurrido un error.',
      );
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTransactionsFraud]);

  const Columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Button variant='outlined' onClick={() => handleIdButtonClick(params.row.id)}>
          {'Ver detalle'}
        </Button>
      ),
    },
    {
      field: 'prevention',
      headerName: 'Prevención',
      width: 200,
      headerAlign: 'center',
      renderCell: (params) => (
        <ActionLabels isFraud={params.row.is_fraud} isChargeback={params.row.is_chargeback} />
      ),
    },
    {
      field: 'created',
      headerName: 'Fecha DB',
      width: 250,

      headerAlign: 'center',
      valueGetter: (params) => {
        return convertToMexicoTime(params);
      },
    },
    {
      field: 'payer_name',
      headerName: 'Ordenante',
      width: 220,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'order_tracking_key',
      headerName: 'clave de rastreo',
      width: 200,

      headerAlign: 'center',
    },

    {
      field: 'payment_concept',
      headerName: 'Concepto pago',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'beneficiary_account',
      headerName: 'Cuenta',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'amount',
      headerName: 'Monto',
      width: 120,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => <CurrencyFormatter amount={params.value} />,
    },
    {
      field: 'reference',
      headerName: 'Referencia',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 200,
      headerAlign: 'center',
      renderCell: (params) => (
        <ActionsMenu
          onFraud={() => handleOpenPopUp('fraud', params.id)}
          onChargeback={() => handleOpenPopUp('chargeback', params.id)}
        />
      ),
    },
  ];

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
    loading,
    page,
    size,
    handleChangePage,
    pagination: {
      ...pagination,
      handleChangePage,
      handleChangePageSize,
    },
    rows,
    mappedRows,
    Columns,
    isDialogOpen,
    setIsDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    setErrorMessage,
    openActionFraud,
    handleCloseFraudChargeback,
    setDescriptionTransaction,
    setError,
    error,
    setLoadingFraudAndChargeback,
    loadingFraudAndChargeback,
    isError,
    handleConfirm,
    setOpenActionFraud,
    handleOpenPopUp,
  };
};
